export function findFileDiv<T extends HTMLElement, U extends HTMLElement>(element: T, box: U) {
    if (!box.contains(element)) {
        return;
    }
    if (element instanceof HTMLDivElement && element.classList.contains('c-file-box__file')) {
        return element as HTMLDivElement;
    }
    const parent = element.parentElement as T;
    if (parent) {
        return findFileDiv(parent, box);
    }
}

export function findDeleteButton<T extends HTMLElement, U extends HTMLElement>(element: T, box: U) {
    if (!box.contains(element)) {
        return;
    }
    if (element instanceof HTMLButtonElement && element.classList.contains('o-button')) {
        return element as HTMLButtonElement;
    }
    const parent = element.parentElement as T;
    if (parent) {
        return findDeleteButton(parent, box);
    }
}

export function findFormControl<T extends HTMLElement>(element: T) {
    if (element === document.body || !document.body.contains(element)) {
        return;
    }
    if (element instanceof HTMLDivElement && element.classList.contains('o-form-control')) {
        return element as HTMLDivElement;
    }
    const parent = element.parentElement as T;
    if (parent) {
        return findFormControl(parent);
    }
}

export function fileUploadUrl(prefix:string, appGuid: string) {
    return `/webhooks/${prefix}upload/${appGuid}` as const;
}

export function fileDeleteUrl(prefix:string, appGuid: string, fileId: string) {
    return `/webhooks/${prefix}delete/${appGuid}/${fileId}` as const;
}

export function formatFormData(file: File, tags: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.set('Content-Type', file.type);
    formData.set('tags', tags)
    return formData;
}

export function isAdvancedUpload() {
    var div = document.createElement('div');
    return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
};

export function addListenerMulti(element, eventNames, callback) {
    const events = eventNames.split(' ');
    events.forEach(event => {
        element.addEventListener(event, callback, false);
    })
};

export const isError = (err: any): err is Error => {
    return (
        err &&
        err.stack !== undefined &&
        err.message !== undefined &&
        typeof err.stack === 'string' &&
        typeof err.message === 'string'
    )
}